import React from 'react';
import './Friend-count.css'

const FriendCount = (props) => {
    const users = props.allUser;
  
    let total = 0;
    for(let i=0; i<users.length; i++){
        const ur = users[i];
        total = total + ur.annualIncome;
    }
    
    return (
        <div className="d-flex">
            <h3>Number of Friends Donated: <br/><span>{users.length}</span></h3>
            <h3>Total Donation:<br/><span>{total}</span></h3>
        </div>
    );
};

export default FriendCount;